$(function() {
    if ($(window).width() < 1200) {
        infoRotation();
    }
});

function infoRotation() {
    const currentInfoStats = sessionStorage.infoStats ?? 'water';

    if (currentInfoStats === 'water') {
        // Show air forecast
        sessionStorage.infoStats = 'air';
        $('[data-info-rotation="water"]').hide();
        $('[data-info-rotation="air"]').css('display', 'flex');  
    } else {
        // Show water forecast
        sessionStorage.infoStats = 'water';
        $('[data-info-rotation="air"]').hide();
        $('[data-info-rotation="water"]').css('display', 'flex');
    }
}